import tokioPromo from "../assets/tokio-promo.png";
import nyPromo from "../assets/ny-promo.png";
import londresPromo from "../assets/londres-promo.png";
import parisPromo from "../assets/paris-promo.png";
import kiotoPromo from "../assets/kioto-promo.png";
import osakaPromo from "../assets/osaka-promo.png";
import seulPromo from "../assets/seul-promo.png";
import bangkokPromo from "../assets/bangkok-promo.png";
import baliPromo from "../assets/bali-promo.png";
import pekinPromo from "../assets/pekin-promo.png";
import kualaLumpurPromo from "../assets/kuala-lumpur-promo.png";
import sanFranciscoPromo from "../assets/san-francisco-promo.png";
import belgicaPromo from "../assets/belgica-promo.png";
import edimburgoPromo from "../assets/edimburgo-promo.png";

/** Portadas del catálogo de guías (mismas que la home de blog-home). */
export const GUIDE_CATALOG_IMAGES = {
	tokio: tokioPromo,
	ny: nyPromo,
	londres: londresPromo,
	paris: parisPromo,
	kioto: kiotoPromo,
	osaka: osakaPromo,
	seul: seulPromo,
	bangkok: bangkokPromo,
	bali: baliPromo,
	pekin: pekinPromo,
	kualaLumpur: kualaLumpurPromo,
	sanFrancisco: sanFranciscoPromo,
	belgica: belgicaPromo,
	edimburgo: edimburgoPromo,
	japon: tokioPromo,
};

/** Título Titan One de cada portada (fill/stroke como en la guía). */
export const GUIDE_COVER_TITLES = {
	kioto: { label: "Kioto", fill: "#fabe73", stroke: "#402617" },
	tokio: { label: "Tokio", fill: "#e24217", stroke: "#24221a" },
	ny: { label: "Nueva York", fill: "#59c3d8", stroke: "#0c2d32" },
	londres: { label: "Londres", fill: "#de5624", stroke: "#361509" },
	seul: { label: "Seúl", fill: "#64cec1", stroke: "#2B1E17" },
	paris: { label: "París", fill: "#7fb4e7", stroke: "#2c3e50" },
	sanFrancisco: { label: "San Francisco", fill: "#F2B705", stroke: "#241b00" },
	bangkok: { label: "Bangkok", fill: "#E8A838", stroke: "#2B1E17" },
	osaka: { label: "Osaka", fill: "#4ec097", stroke: "#112820" },
	kualaLumpur: { label: "Kuala Lumpur", fill: "#43bc88", stroke: "#153729" },
	belgica: { label: "Bélgica", fill: "#edb729", stroke: "#241b03" },
	pekin: { label: "Pekín", fill: "#C41E3A", stroke: "#1a0a0a" },
	bali: { label: "Bali", fill: "#54b789", stroke: "#12291e" },
	edimburgo: { label: "Edimburgo", fill: "#95bef8", stroke: "#1e3f70" },
	japon: { label: "Japón", fill: "#e24217", stroke: "#24221a" },
};

export const GUIDE_CATALOG_ORDER = [
	"kioto",
	"tokio",
	"ny",
	"londres",
	"edimburgo",
	"seul",
	"paris",
	"sanFrancisco",
	"bangkok",
	"osaka",
	"kualaLumpur",
	"belgica",
	"pekin",
	"bali",
];

export function sortGuideCatalog(guides = []) {
	const index = new Map(GUIDE_CATALOG_ORDER.map((id, i) => [id, i]));
	return [...guides].sort((a, b) => {
		const ai = index.has(a.id) ? index.get(a.id) : GUIDE_CATALOG_ORDER.length;
		const bi = index.has(b.id) ? index.get(b.id) : GUIDE_CATALOG_ORDER.length;
		return ai - bi;
	});
}
